import { CartIconStore } from './cartIconStore';
import { withErrorReporting } from '@wix/wixstores-client-core/dist/es/src/viewer-script/errorReporter';
import { specs } from '../constants';
import { APP_DEFINITION_ID } from '@wix/wixstores-client-core/dist/src/constants';
export function cartWidgetController(controllerFactoryConfig) {
    var cartIconStore;
    var siteStore;
    var compId = controllerFactoryConfig.compId, config = controllerFactoryConfig.config, platformAPIs = controllerFactoryConfig.platformAPIs, setProps = controllerFactoryConfig.setProps, factoryContext = controllerFactoryConfig.context, reportError = controllerFactoryConfig.reportError;
    var trackEventBi = function (productId, hasOptions, quantity) {
        var eventData = {
            appName: 'wixstores-cart-icon',
            hasOptions: hasOptions,
            productId: productId,
            origin: 'cart-icon',
            isNavigateCart: false,
            quantity: quantity,
        };
        return siteStore.biLogger.clickOnAddToCartSf(eventData);
    };
    var trackEvent = function (productId, quantity) {
        var params = {
            appDefId: APP_DEFINITION_ID,
            category: 'All Products',
            origin: 'Stores',
            id: productId,
            quantity: quantity,
        };
        return siteStore.windowApis.trackEvent('AddToCart', params);
    };
    var onAddToCartBi = function (productId, hasOptions, quantity) {
        if (siteStore.experiments.enabled(specs.stores.CartIconAddToCartBiEvent2)) {
            return Promise.all([trackEventBi(productId, hasOptions, quantity), trackEvent(productId, quantity)]);
        }
    };
    return {
        pageReady: function () {
            siteStore = factoryContext.siteStore;
            cartIconStore = new CartIconStore(siteStore, config, compId, setProps, reportError, platformAPIs);
            return cartIconStore.setInitialState();
        },
        updateConfig: function (_$w, updatedConfig) {
            config.style = updatedConfig.style;
            config.publicData = updatedConfig.publicData;
            setProps({
                displayText: cartIconStore.getDisplayText(updatedConfig.publicData ? updatedConfig.publicData.appSettings : {}),
            });
        },
        onBeforeUnLoad: function () {
            cartIconStore.unSubscribeAll();
        },
        exports: function () {
            return withErrorReporting(controllerFactoryConfig.reportError)({
                addToCart: function (productId, quantity, options) {
                    if (quantity === void 0) { quantity = 1; }
                    if (options === void 0) { options = {}; }
                    //tslint:disable-next-line:no-floating-promises
                    onAddToCartBi(productId, !!(options && options.choices), quantity);
                    //tslint:disable-line
                    return cartIconStore.addToCart("" + productId, quantity, options);
                },
                addProductsToCart: function (cartItems) {
                    cartItems.forEach(function (item) {
                        //tslint:disable-next-line:no-floating-promises
                        return onAddToCartBi(item.productID, !!(item.options && item.options.choices), item.quantity);
                    });
                    return cartIconStore.addItemsToCart(cartItems);
                },
            });
        },
    };
}
//# sourceMappingURL=cartIconController.js.map